<template>
  <page :title="title" :breadcrumb="breadcrumb">
    <!-- <div slot="pageAction">
      <div class="actionBlock">
        <v-menu offset-y :min-width="250">
          <v-btn text color="secondary" v-on="on">
            More Links...
            <v-icon right>mdi-link</v-icon>
          </v-btn>
          <side-function-menu :items="sideFunction" @doClick="$router.push($event)"></side-function-menu>
        </v-menu>
      </div>
    </div> -->
    <v-card>
      <!--
      <v-card-title>
        <div class="title" v-if="!newDefTxt">{{scrRef}} - {{txtRef}}</div>
        <div class="title" v-else>New Default Text</div>
      </v-card-title>
      -->
      <transition name="slide-x-transition" mode="out-in">
        <router-view></router-view>
      </transition>
    </v-card>
  </page>
</template>

<script>
import { mapGetters } from 'vuex'
// import SideFunctionMenu from '@/components/core/claimManagement/sideFunction/SideFunctionMenu'
export default {
  data() {
    return {
      title: 'Manage Default Text',
      breadcrumb: [],
      sideFunction: [
        {
          text: 'Default Text',
          icon: 'mdi-launch',
          iconColor: 'primary',
          params: { name: 'defTextDet' }
        }
      ],
      scrRef: null,
      txtRef: null
    }
  },
  created() {
    this.doBreadcrumb()
  },
  mounted() {
    this.doInit()
  },
  methods: {
    doBreadcrumb() {
      switch (this.$route.name) {
        case 'defTextDet': {
          this.breadcrumb = this.derieveBreadcrumbByName('defTextReview')
          this.title = 'Manage Default Text'
          break
        }
        case 'polTypeDefTxt': {
          this.breadcrumb = this.derieveBreadcrumbByName('polTypeDefTxt')
          this.title = 'Permitted Default Text per Policy Type'
          break
        }
        case 'busClsDefTxt': {
          this.breadcrumb = this.derieveBreadcrumbByName('busClsDefTxt')
          this.title = 'Permitted Default Text per Business Class'
          break
        }
      }
    },
    async doInit() {
      if (!this.newDefTxt) {
        const id = this.id.split('_')
        this.scrRef = id[0]
        this.txtRef = id[1]
        if (this.polTypeDefTxtValid.includes(this.scrRef)) {
          this.sideFunction.push({
            text: 'Permitted Default Text per Policy Type',
            icon: 'mdi-launch',
            iconColor: 'primary',
            params: { name: 'polTypeDefTxt' }
          })
        }
        if (this.busClsDefTxtValid.includes(this.scrRef)) {
          this.sideFunction.push({
            text: 'Permitted Default Text per Business Class',
            icon: 'mdi-launch',
            iconColor: 'primary',
            params: { name: 'busClsDefTxt' }
          })
        }
      }
    }
  },
  computed: {
    ...mapGetters(['derieveBreadcrumbByName']),
    menu() {
      return this.$store.state.docFormatParam.menu
    },
    newDefTxt() {
      return this.id === 'new'
    },
    polTypeDefTxtValid: () => ['01', '02', '03', '04', '05', '10', '11'],
    busClsDefTxtValid: () => ['20', '21', '22', '30', '31', '32']
  },
  watch: {
    '$route.name'(value) {
      this.doBreadcrumb()
    },
    id: {
      handler() {
        this.doInit()
      },
      deep: true
    }
  },
  // components: {
  //   SideFunctionMenu
  // },
  props: ['id']
}
</script>

<style lang="scss">
@import '@/assets/scss/base.scss';
.queryPnl {
  margin-top: 50px;
}
</style>
